export function isExtensionInReview(status?: string): boolean {
  return status === 'En revisión' || status === 'IN_REVIEW';
}
